import * as React from "react";
const SvgPlatformLogoStrava = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} xmlns="http://www.w3.org/2000/svg" aria-label="Strava" role="img" viewBox="0 0 512 512" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<circle cx={256} cy={256} r={256} fill="#fc4c01" /><path fill="#ffffff" d="M120 288L232 56l112 232h-72l-40-96-40 96z" /><path fill="#fda580" d="M280 288l32 72 32-72h48l-80 168-80-168z" /></svg>;
export default SvgPlatformLogoStrava;